import { render } from "./StickerMode.vue?vue&type=template&id=ee27f3a2&scoped=true"
import script from "./StickerMode.vue?vue&type=script&lang=js"
export * from "./StickerMode.vue?vue&type=script&lang=js"

import "./StickerMode.vue?vue&type=style&index=0&id=ee27f3a2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee27f3a2"]])

export default __exports__